import React from "react";
import Grainient from "./Grainient";

/* The upgrade CTA's charcoal grain — the one visual that means "this costs
   money" across the app. Hover warms the same grays into an ember glow rather
   than swapping in a new color. */
const UPGRADE_GRAINIENT: React.ComponentProps<typeof Grainient>["points"] = [
  { x: 0.08, y: 0.2, c: [16, 15, 14] },
  { x: 0.3, y: 0.5, c: [55, 52, 47] },
  { x: 0.5, y: 0.85, c: [44, 42, 39] },
  { x: 0.85, y: 0.15, c: [72, 67, 60] },
  { x: 1.05, y: 0.8, c: [30, 29, 27] },
];

/* Primary upgrade button — grained, never flat brand, so it reads as the one
   commercial action on the screen instead of one more black button. */
export function UpgradeButton({ className = "", children, ...rest }: React.ComponentPropsWithoutRef<"button">) {
  return (
    <button
      {...rest}
      className={`press group relative isolate overflow-hidden flex items-center justify-center gap-1.5 rounded-[8px] px-4 h-8 text-[12.5px] font-semibold text-white ring-1 ring-white/10 shadow-[inset_0_1px_0_rgba(255,255,255,0.18),inset_0_-1px_0_rgba(0,0,0,0.35),0_2px_4px_rgba(0,0,0,0.25),0_6px_14px_rgba(0,0,0,0.18)] ${className}`}
    >
      <Grainient
        points={UPGRADE_GRAINIENT}
        seed={43}
        flow={[1.8, 0.3]}
        className="absolute inset-0 w-full h-full -z-10 transition-[filter] duration-500 group-hover:[filter:sepia(.55)_saturate(2.4)_brightness(1.15)]"
      />
      {children}
    </button>
  );
}

/* Every upgrade CTA ends in the same place: Billing, where the card gets
   charged. Settings is a page the shell opens, so a CTA asks for it by event
   instead of knowing how the shell navigates. */
export const openBilling = () => window.dispatchEvent(new CustomEvent("open-billing"));
